import type { LocationQueryRaw } from "vue-router";
import useMaintenanceEvents from "@/composables/maintenance-events";
import { useSystemBannersStore } from "@/store/systemBanners";
import { DATE_FORMAT, TIME_FORMAT } from "@lib/constants/system";

export default defineNuxtRouteMiddleware(async (to) => {
    const $router = useRouter();
    const bannerStore = useSystemBannersStore();
    const { isAndroid } = usePlatform();

    if (isAndroid.value) {
        return;
    }

    const { activeMaintenanceEvent, upcomingMaintenanceEvent, setEventShownToday } =
        await useMaintenanceEvents();

    if (upcomingMaintenanceEvent) {
        bannerStore.setBannerWithTranslation(
            "maintenance-banner.message",
            {
                plannedStartDate: formatDateTime(
                    upcomingMaintenanceEvent.planned_start,
                    DATE_FORMAT,
                ),
                plannedStartTime: formatDateTime(
                    upcomingMaintenanceEvent.planned_start,
                    TIME_FORMAT,
                ),
                plannedEndDate: formatDateTime(
                    upcomingMaintenanceEvent.planned_end,
                    DATE_FORMAT,
                ),
                plannedEndTime: formatDateTime(
                    upcomingMaintenanceEvent.planned_end,
                    TIME_FORMAT,
                ),
            },
            "info",
            () => {
                if (upcomingMaintenanceEvent?.id) {
                    setEventShownToday(upcomingMaintenanceEvent.id);
                }
            },
        );
    }

    // // Return to prev page from maintenance
    if (!activeMaintenanceEvent && to.path.startsWith("/maintenance")) {
        let url = "/";
        if ("next" in to.query) {
            url = to.query.next as string;
        }
        $router.replace(url);
        return;
    }
    if (activeMaintenanceEvent && !to.path.startsWith("/maintenance")) {
        const query = {} as LocationQueryRaw;
        if (to.path !== "/") {
            query.next = to.path;
        }
        $router.replace({ path: "/maintenance", query });
    }
});
